/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MessageTypeEnum = 'EMAIL' | 'TOAST' | 'BANNER';

export const MessageTypeEnum = {

    EMAIL: 'EMAIL' as MessageTypeEnum,

    TOAST: 'TOAST' as MessageTypeEnum,

    BANNER: 'BANNER' as MessageTypeEnum
};

